// sp
const sm = 620;
// tablet
const md = 870;
// pc
const lg = 1080;
// pc-menu

type Screen = 'sp' | 'tablet' | 'pc' | 'pc-menu';

export const getScreen = (
  screen: Screen,
  comparison: '以上' | 'のみ' | '以下' | '未満' = '以上',
) => {
  const offset = comparison === '未満' ? -1 : 0;
  const screenIndex =
    ['sp', 'tablet', 'pc', 'pc-menu'].indexOf(screen) + offset;

  const smallBreakpoint = [sm, md, lg][screenIndex - 1] || null;
  const largeBreakpoint = [sm, md, lg][screenIndex] || null;

  return [
    comparison !== '以下' &&
      comparison !== '未満' &&
      smallBreakpoint &&
      `(min-width: ${smallBreakpoint + 1}px)`,
    comparison !== '以上' &&
      largeBreakpoint &&
      `(max-width: ${largeBreakpoint}px)`,
  ]
    .filter((item): item is string => typeof item === 'string')
    .join(' and ');
};
